export default "__VITE_ASSET__BtgY0$17__"